import TeamTransferConfirm from '@/screens/TeamTransferConfirm';

export default function PrivateTeamTeamIdEditTransferTransferIdRoute() {
  return <TeamTransferConfirm />;
}
